'use strict';

import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _typeof from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
var _require = require('../../../api'),
  getRawDataApi = _require.getRawDataApi;
var ExcelJS = require('exceljs');
var HV_METER = 'HV-meter';
var LV_METER = 'LV-meter';
var PVTEMP = 'PVTemp';
var ENVTEMP = 'ENVTemp';
var ANEMOMETER = 'Anemometer';
var RAWDATA_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
var rawDataDownload = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(factory, date, selectedOptions) {
    var _result$data;
    var result, factoryName, data, workbook, firstData, invLength, baseColumn, meterKeys, selectedHVmeter, ws, fieldsColumn, selectedLVmeter, _ws, _fieldsColumn, selectedIRRList, selectedPVTemp, _ws2, selectedENVTemp, _ws3, selectedAnemometer, _ws4, selectedINVList, invRowKeys, detailColumns, eventLength, eventIndex, pvLength, pvIndex, attachment, url, link;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getRawDataApi(factory, date);
          case 2:
            result = _context.sent;
            if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.success) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", false);
          case 5:
            factoryName = factory.split('_')[0];
            data = result.data.data;
            workbook = new ExcelJS.Workbook(); // create excel
            firstData = data[0];
            invLength = firstData.detail.acp && firstData.detail.acp.length;
            baseColumn = [{
              header: '案場名稱',
              key: 'siteName',
              width: 15
            }, {
              header: '設備名稱',
              key: 'device',
              width: 15
            }, {
              header: '時間',
              key: 'time',
              width: 20
            }];
            meterKeys = [{
              key: 'Freq',
              name: '頻率'
            }, {
              key: 'I_a',
              name: 'A 相電流'
            }, {
              key: 'I_b',
              name: 'B 相電流'
            }, {
              key: 'I_c',
              name: 'C 相電流'
            }, {
              key: 'KVAR_tot',
              name: '虛功率'
            }, {
              key: 'KVA_tot',
              name: '視在功率'
            }, {
              key: 'P',
              name: '平均功率'
            }, {
              key: 'Vll_ab',
              name: 'AB 相電壓'
            }, {
              key: 'Vll_bc',
              name: 'BC 相電壓'
            }, {
              key: 'Vll_ca',
              name: 'AC 相電壓'
            }, {
              key: 'Vln_a',
              name: 'A 相電壓'
            }, {
              key: 'Vln_b',
              name: 'B 相電壓'
            }, {
              key: 'Vln_c',
              name: 'C 相電壓'
            }]; // HV_METER
            selectedHVmeter = selectedOptions.includes(HV_METER);
            if (selectedHVmeter && firstData.detail.etc && firstData.detail.etc[HV_METER]) {
              ws = workbook.addWorksheet(HV_METER);
              fieldsColumn = meterKeys.map(function (k) {
                return {
                  header: "".concat(k.name, " ").concat(k.key),
                  key: "".concat(k.name, " ").concat(k.key),
                  width: 15
                };
              });
              ws.columns = [].concat(baseColumn, _toConsumableArray(fieldsColumn));
            }

            // LV_METER
            selectedLVmeter = selectedOptions.includes(LV_METER);
            if (selectedLVmeter && firstData.detail.etc && firstData.detail.etc[LV_METER]) {
              _ws = workbook.addWorksheet(LV_METER);
              _fieldsColumn = meterKeys.map(function (k) {
                return {
                  header: "".concat(k.name, " ").concat(k.key),
                  key: "".concat(k.name, " ").concat(k.key),
                  width: 15
                };
              });
              _ws.columns = [].concat(baseColumn, _toConsumableArray(_fieldsColumn));
            }

            // IRR
            selectedIRRList = selectedOptions.filter(function (item) {
              return item.match('IRR');
            });
            if (selectedIRRList !== null && selectedIRRList !== void 0 && selectedIRRList.length && firstData.detail.IRR && firstData.detail.IRR.length) {
              selectedIRRList.sort(function (a, b) {
                return a.split('_')[1] - b.split('_')[1];
              }).forEach(function (irr) {
                var ws = workbook.addWorksheet(irr);
                ws.columns = [].concat(baseColumn, [{
                  header: 'IRR_顯示值',
                  key: 'value',
                  width: 15
                }]);
              });
            }

            // PVTemp
            selectedPVTemp = selectedOptions.includes(PVTEMP);
            if (selectedPVTemp && firstData.detail && typeof firstData.detail.PVTemp === 'number') {
              _ws2 = workbook.addWorksheet(PVTEMP);
              _ws2.columns = [].concat(baseColumn, [{
                header: '模組溫度 temp',
                key: 'value',
                width: 15
              }]);
            }

            // ENVTemp
            selectedENVTemp = selectedOptions.includes(ENVTEMP);
            if (selectedENVTemp && firstData.detail && typeof firstData.detail.ENVTemp === 'number') {
              _ws3 = workbook.addWorksheet(ENVTEMP);
              _ws3.columns = [].concat(baseColumn, [{
                header: '環境溫度 temp',
                key: 'value',
                width: 15
              }]);
            }

            // Anemometer
            selectedAnemometer = selectedOptions.includes(ANEMOMETER);
            if (selectedAnemometer && firstData.detail && typeof firstData.detail.Anemometer === 'number') {
              _ws4 = workbook.addWorksheet(ANEMOMETER);
              _ws4.columns = [].concat(baseColumn, [{
                header: '風速計值',
                key: 'value',
                width: 15
              }]);
            }

            // INV
            selectedINVList = selectedOptions.filter(function (item) {
              return item.match('INV');
            });
            if (selectedINVList !== null && selectedINVList !== void 0 && selectedINVList.length) {
              invRowKeys = [{
                key: 'pv_v',
                name: '串列電壓'
              }, {
                key: 'pv_a',
                name: '串列電流'
              }, {
                key: 'pv_p',
                name: '串列功率'
              }, {
                key: 'temp',
                name: '變流器溫度'
              }, {
                key: 'event',
                name: '事件'
              }, {
                key: 'PF',
                name: '功率因數'
              }, {
                key: 'Vrn',
                name: 'R 相電壓'
              }, {
                key: 'Vsn',
                name: 'S 相電壓'
              }, {
                key: 'Vtn',
                name: 'T 相電壓'
              }, {
                key: 'Rc',
                name: 'R 相電流'
              }, {
                key: 'Sc',
                name: 'S 相電流'
              }, {
                key: 'Tc',
                name: 'T 相電流'
              }, {
                key: 'Eff',
                name: '變流器轉換效率'
              }, {
                key: 'State',
                name: '裝置狀態'
              }, {
                key: 'acp',
                name: '交流功率'
              }, {
                key: 'dcp',
                name: '直流功率'
              }, {
                key: 'E_today',
                name: '今日發電量'
              }, {
                key: 'AC_kWh',
                name: '累積發電量'
              }, {
                key: 'freq',
                name: '頻率'
              }, {
                key: 'Insulation',
                name: '絕緣阻抗'
              }, {
                key: 'power_r',
                name: 'R 相發電'
              }, {
                key: 'power_s',
                name: 'S 相發電'
              }, {
                key: 'power_t',
                name: 'T 相發電'
              }, {
                key: 'capacity',
                name: '裝置容量'
              }];
              detailColumns = baseColumn; // 有的案場每台 INV pv、event 長度不同，先找出數量最多的那台，以那台數量為基準列出 row 數量
              eventLength = Math.max.apply(Math, _toConsumableArray(firstData.detail.event.map(function (item) {
                return item.length;
              })));
              eventIndex = firstData.detail.event.findIndex(function (item) {
                return item.length === eventLength;
              });
              pvLength = Math.max.apply(Math, _toConsumableArray(firstData.detail.pv_a.map(function (item) {
                return item.length;
              })));
              pvIndex = firstData.detail.pv_v.findIndex(function (item) {
                return item.length === pvLength;
              });
              invRowKeys.forEach(function (invKey) {
                var _firstData$detail$inv, _firstData$detail$inv2, _firstData$detail$inv3;
                var index = invKey.key === 'event' ? eventIndex : invKey.key.split('_')[0] === 'pv' ? pvIndex : 0;
                if ((_firstData$detail$inv = firstData.detail[invKey.key]) !== null && _firstData$detail$inv !== void 0 && _firstData$detail$inv[index] && _typeof((_firstData$detail$inv2 = firstData.detail[invKey.key]) === null || _firstData$detail$inv2 === void 0 ? void 0 : _firstData$detail$inv2[index]) === 'object' && ((_firstData$detail$inv3 = firstData.detail[invKey.key]) === null || _firstData$detail$inv3 === void 0 ? void 0 : _firstData$detail$inv3[index].length) > 0) {
                  firstData.detail[invKey.key][index].forEach(function (_, idx) {
                    detailColumns.push({
                      header: "".concat(invKey.name, " ").concat(invKey.key).concat(idx + 1),
                      key: "".concat(invKey.name, " ").concat(invKey.key).concat(idx + 1),
                      width: 17
                    });
                  });
                } else {
                  detailColumns.push({
                    header: "".concat(invKey.name, " ").concat(invKey.key),
                    key: "".concat(invKey.name, " ").concat(invKey.key),
                    width: 17
                  });
                }
              });
              selectedINVList.sort(function (a, b) {
                return a.split('_')[1] - b.split('_')[1];
              }).forEach(function (inv) {
                var ws = workbook.addWorksheet(inv);
                ws.columns = detailColumns;
              });
            }

            // add data to row
            data.forEach(function (doc, docIdx) {
              var rowBase = {
                siteName: doc.factoryName
              };
              var hvMeterWorksheet = workbook.getWorksheet(HV_METER);
              var lvMeterWorksheet = workbook.getWorksheet(LV_METER);
              var pvTempWorksheet = workbook.getWorksheet(PVTEMP);
              var envTempWorksheet = workbook.getWorksheet(ENVTEMP);
              var anemometerWorksheet = workbook.getWorksheet(ANEMOMETER);
              var time = DateTime.fromISO(doc.timestamp.split('Z')[0]).toFormat(RAWDATA_TIME_FORMAT);
              if (hvMeterWorksheet) {
                var hvMeterData = meterKeys.reduce(function (accumulator, curr) {
                  accumulator["".concat(curr.name, " ").concat(curr.key)] = doc.detail.etc[HV_METER][curr.key];
                  return accumulator;
                }, {});
                var etcRowsHV = _objectSpread(_objectSpread({}, docIdx === 0 ? rowBase : {}), {}, {
                  device: docIdx === 0 ? '高壓電表' : '',
                  time: time
                }, hvMeterData);
                hvMeterWorksheet.addRow(etcRowsHV);
              }
              if (lvMeterWorksheet) {
                var lvMeterData = meterKeys.reduce(function (accumulator, curr) {
                  accumulator["".concat(curr.name, " ").concat(curr.key)] = doc.detail.etc[LV_METER][curr.key];
                  return accumulator;
                }, {});
                var etcRowsLV = _objectSpread(_objectSpread({}, docIdx === 0 ? rowBase : {}), {}, {
                  device: docIdx === 0 ? '低壓電表' : '',
                  time: time
                }, lvMeterData);
                lvMeterWorksheet.addRow(etcRowsLV);
              }
              if (pvTempWorksheet) {
                var pvTempRows = _objectSpread(_objectSpread({}, docIdx === 0 ? rowBase : {}), {}, {
                  device: docIdx === 0 ? '模組溫度' : '',
                  time: time,
                  value: doc.detail.PVTemp ? doc.detail.PVTemp : 0
                });
                pvTempWorksheet.addRow(pvTempRows);
              }
              if (envTempWorksheet) {
                var envTempRows = _objectSpread(_objectSpread({}, docIdx === 0 ? rowBase : {}), {}, {
                  device: docIdx === 0 ? '環境溫度' : '',
                  time: time,
                  value: doc.detail.ENVTemp ? doc.detail.ENVTemp : 0
                });
                envTempWorksheet.addRow(envTempRows);
              }
              if (anemometerWorksheet) {
                var anemometerRows = _objectSpread(_objectSpread({}, docIdx === 0 ? rowBase : {}), {}, {
                  device: docIdx === 0 ? '風速計' : '',
                  time: time,
                  value: doc.detail.Anemometer ? doc.detail.Anemometer : 0
                });
                anemometerWorksheet.addRow(anemometerRows);
              }

              // IRR row
              if (selectedIRRList !== null && selectedIRRList !== void 0 && selectedIRRList.length) {
                doc.detail.IRR.forEach(function (irr, irrIdx) {
                  var foundIRR = selectedIRRList.find(function (irrItem) {
                    return irrItem.split('_')[1] - 1 === irrIdx;
                  });
                  if (foundIRR) {
                    var irrRows = _objectSpread(_objectSpread({}, docIdx === 0 ? rowBase : {}), {}, {
                      time: time,
                      device: docIdx === 0 ? '日照計 ' + foundIRR : '',
                      value: irr
                    });
                    workbook.getWorksheet(foundIRR).addRow(irrRows);
                  }
                });
              }

              // INV row
              if (selectedINVList !== null && selectedINVList !== void 0 && selectedINVList.length) {
                var _loop = function _loop(i) {
                  var foundINV = selectedINVList.find(function (invItem) {
                    return invItem.split('_')[1] - 1 === i;
                  });
                  if (foundINV) {
                    var _doc$detail, _doc$detail$PF, _doc$detail2, _doc$detail2$Vrn, _doc$detail3, _doc$detail3$Vsn, _doc$detail4, _doc$detail4$Vtn, _doc$detail5, _doc$detail5$Rc, _doc$detail6, _doc$detail6$Sc, _doc$detail7, _doc$detail7$Tc, _doc$detail8, _doc$detail8$freq, _doc$detail9, _doc$detail9$Eff, _doc$detail10, _doc$detail10$State, _doc$detail11, _doc$detail11$acp, _doc$detail12, _doc$detail12$dcp, _doc$detail13, _doc$detail13$E_today, _doc$detail14, _doc$detail14$AC_kWh, _doc$detail15, _doc$detail15$Insulat, _doc$detail16, _doc$detail16$power_r, _doc$detail17, _doc$detail17$power_s, _doc$detail18, _doc$detail18$power_t, _doc$detail19, _doc$detail19$capacit;
                    var _ws5 = workbook.getWorksheet(foundINV);
                    var row = _objectSpread(_objectSpread({}, docIdx === 0 ? rowBase : {}), {}, {
                      time: time,
                      device: docIdx === 0 ? '變流器 ' + foundINV : '',
                      '功率因數 PF': (_doc$detail = doc.detail) === null || _doc$detail === void 0 ? void 0 : (_doc$detail$PF = _doc$detail.PF) === null || _doc$detail$PF === void 0 ? void 0 : _doc$detail$PF[i],
                      'R 相電壓 Vrn': (_doc$detail2 = doc.detail) === null || _doc$detail2 === void 0 ? void 0 : (_doc$detail2$Vrn = _doc$detail2.Vrn) === null || _doc$detail2$Vrn === void 0 ? void 0 : _doc$detail2$Vrn[i],
                      'S 相電壓 Vsn': (_doc$detail3 = doc.detail) === null || _doc$detail3 === void 0 ? void 0 : (_doc$detail3$Vsn = _doc$detail3.Vsn) === null || _doc$detail3$Vsn === void 0 ? void 0 : _doc$detail3$Vsn[i],
                      'T 相電壓 Vtn': (_doc$detail4 = doc.detail) === null || _doc$detail4 === void 0 ? void 0 : (_doc$detail4$Vtn = _doc$detail4.Vtn) === null || _doc$detail4$Vtn === void 0 ? void 0 : _doc$detail4$Vtn[i],
                      'R 相電流 Rc': (_doc$detail5 = doc.detail) === null || _doc$detail5 === void 0 ? void 0 : (_doc$detail5$Rc = _doc$detail5.Rc) === null || _doc$detail5$Rc === void 0 ? void 0 : _doc$detail5$Rc[i],
                      'S 相電流 Sc': (_doc$detail6 = doc.detail) === null || _doc$detail6 === void 0 ? void 0 : (_doc$detail6$Sc = _doc$detail6.Sc) === null || _doc$detail6$Sc === void 0 ? void 0 : _doc$detail6$Sc[i],
                      'T 相電流 Tc': (_doc$detail7 = doc.detail) === null || _doc$detail7 === void 0 ? void 0 : (_doc$detail7$Tc = _doc$detail7.Tc) === null || _doc$detail7$Tc === void 0 ? void 0 : _doc$detail7$Tc[i],
                      '頻率 freq': (_doc$detail8 = doc.detail) === null || _doc$detail8 === void 0 ? void 0 : (_doc$detail8$freq = _doc$detail8.freq) === null || _doc$detail8$freq === void 0 ? void 0 : _doc$detail8$freq[i],
                      '變流器轉換效率 Eff': (_doc$detail9 = doc.detail) === null || _doc$detail9 === void 0 ? void 0 : (_doc$detail9$Eff = _doc$detail9.Eff) === null || _doc$detail9$Eff === void 0 ? void 0 : _doc$detail9$Eff[i],
                      '裝置狀態 State': (_doc$detail10 = doc.detail) === null || _doc$detail10 === void 0 ? void 0 : (_doc$detail10$State = _doc$detail10.State) === null || _doc$detail10$State === void 0 ? void 0 : _doc$detail10$State[i],
                      '交流功率 acp': (_doc$detail11 = doc.detail) === null || _doc$detail11 === void 0 ? void 0 : (_doc$detail11$acp = _doc$detail11.acp) === null || _doc$detail11$acp === void 0 ? void 0 : _doc$detail11$acp[i],
                      '直流功率 dcp': (_doc$detail12 = doc.detail) === null || _doc$detail12 === void 0 ? void 0 : (_doc$detail12$dcp = _doc$detail12.dcp) === null || _doc$detail12$dcp === void 0 ? void 0 : _doc$detail12$dcp[i],
                      '今日發電量 E_today': (_doc$detail13 = doc.detail) === null || _doc$detail13 === void 0 ? void 0 : (_doc$detail13$E_today = _doc$detail13.E_today) === null || _doc$detail13$E_today === void 0 ? void 0 : _doc$detail13$E_today[i],
                      '累積發電量 AC_kWh': (_doc$detail14 = doc.detail) === null || _doc$detail14 === void 0 ? void 0 : (_doc$detail14$AC_kWh = _doc$detail14.AC_kWh) === null || _doc$detail14$AC_kWh === void 0 ? void 0 : _doc$detail14$AC_kWh[i],
                      '絕緣阻抗 Insulation': (_doc$detail15 = doc.detail) === null || _doc$detail15 === void 0 ? void 0 : (_doc$detail15$Insulat = _doc$detail15.Insulation) === null || _doc$detail15$Insulat === void 0 ? void 0 : _doc$detail15$Insulat[i],
                      'R 相發電 power_r': (_doc$detail16 = doc.detail) === null || _doc$detail16 === void 0 ? void 0 : (_doc$detail16$power_r = _doc$detail16.power_r) === null || _doc$detail16$power_r === void 0 ? void 0 : _doc$detail16$power_r[i],
                      'S 相發電 power_s': (_doc$detail17 = doc.detail) === null || _doc$detail17 === void 0 ? void 0 : (_doc$detail17$power_s = _doc$detail17.power_s) === null || _doc$detail17$power_s === void 0 ? void 0 : _doc$detail17$power_s[i],
                      'T 相發電 power_t': (_doc$detail18 = doc.detail) === null || _doc$detail18 === void 0 ? void 0 : (_doc$detail18$power_t = _doc$detail18.power_t) === null || _doc$detail18$power_t === void 0 ? void 0 : _doc$detail18$power_t[i],
                      '裝置容量 capacity': (_doc$detail19 = doc.detail) === null || _doc$detail19 === void 0 ? void 0 : (_doc$detail19$capacit = _doc$detail19.capacity) === null || _doc$detail19$capacit === void 0 ? void 0 : _doc$detail19$capacit[i]
                    });
                    doc.detail.pv_v[i] && doc.detail.pv_v[i].forEach(function (pv, pvIdx) {
                      row["\u4E32\u5217\u96FB\u58D3 pv_v".concat(pvIdx + 1)] = pv;
                    });
                    doc.detail.pv_a[i] && doc.detail.pv_a[i].forEach(function (pv, pvIdx) {
                      row["\u4E32\u5217\u96FB\u6D41 pv_a".concat(pvIdx + 1)] = pv;
                    });
                    doc.detail.pv_p[i] && doc.detail.pv_p[i].forEach(function (pv, pvIdx) {
                      row["\u4E32\u5217\u529F\u7387 pv_p".concat(pvIdx + 1)] = pv;
                    });
                    doc.detail.temp[i] && doc.detail.temp[i].forEach(function (t, tIdx) {
                      row["\u8B8A\u6D41\u5668\u6EAB\u5EA6 temp".concat(tIdx + 1)] = t;
                    });
                    doc.detail.event[i] && doc.detail.event[i].forEach(function (t, tIdx) {
                      row["\u4E8B\u4EF6 event".concat(tIdx + 1)] = t;
                    });
                    _ws5.addRow(row);
                  }
                };
                for (var i = 0; i < invLength; i++) {
                  _loop(i);
                }
              }
            });

            // if no data
            if (workbook.worksheets.length) {
              _context.next = 29;
              break;
            }
            return _context.abrupt("return", false);
          case 29:
            _context.next = 31;
            return workbook.xlsx.writeBuffer();
          case 31:
            attachment = _context.sent;
            url = window.URL.createObjectURL(new Blob([attachment]));
            link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "".concat(factoryName, "_").concat(date, ".xlsx"));
            link.click();
            return _context.abrupt("return", true);
          case 38:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function rawDataDownload(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export { rawDataDownload };